import { IncomeEntity } from '../entities/income-entity';

export default class State {
  loaded = false;

  items: Array<IncomeEntity> = [];
}
